var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workout-log-history-empty"},[_c('icon-history',{staticClass:"workout-log-history-empty__icon",attrs:{"size":'md2'}}),_c('text-body-extra-small',{staticClass:"workout-log-history-empty__text",attrs:{"line-height":'multi'},domProps:{"innerHTML":_vm._s(_vm.$t('message[\'workout-log.history-empty\']'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }